module.exports = __webpack_public_path__ + "img/icon-countdown.f14d33e5.svg";